import React from 'react';
import { Modal } from 'antd'
import ProductCard from '../Product/MiniCard'

const ModalSelectProducts = ({ visible, products, hide, addToCart }) => {
    return (
		<Modal
			visible={visible}
			onCancel={hide}
			title="Seleccione un producto"
			footer={null}
			width={510}
		>
			{products.map((product, index) =>
				<ProductCard
					{...product}
					index={index}
					key={product.id}
					product={product}
					clickTrigger={() => {
						addToCart(product)
						hide()
					}}
				/>
			)}
        </Modal>
    );
}

export default ModalSelectProducts;
